export const productionArtsPositions = [
  '1st Assistant Director',
  '2nd Unit Director/Stunt Coordinator',
  'Co-Executive Producer',
  'Company Client On Retainer Deal',
  'Costume Designer',
  'Director Of Photography',
  'Editor',
  'Executive Producer',
  'Film/TV Music Composer',
  'Financial Controller',
  'In House Executive',
  'Line Producer',
  'Makeup/Hair Designer',
  'Other',
  'Post Producer',
  'Production Designer',
  'Sound Editor/Designer',
  'VFX Executive',
  'VFX Producer',
  'VFX Supervisor',
];